/* eslint-disable */
import React, { useContext, useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import '../../public/css/Timeline.css';
import api from '../../config/services';
// store
import { StoreContext } from '../../store/StoreProvider';
import Act from '../../store/actions';

const extend_books_pub = []; // 在x軸依照年份依序顯示
const extend_books_info = []; // 在y軸每年書本數量，若該年無書本資料，長度為0
const extend_books_count = []; // 擴增資料，每筆資料的書本數量，若該年無書本資料，數量為0
let old_data = []; // 存放原始資料
let sub_tmpMapData = []; // 傳給PublicationMap的暫存array (累積資料的array)
let animationTrans = true; // 用來判斷給資料的方式: 1. false: 點選柱狀圖，把累計資料整個assign給sub_tmpMapData 2. true: 動畫跑動自動顯示
// 傳資料給PublicationMap.js
function dataTransToMap(info, dispatch, resetMapData) {
	const tmpMapData = []; // 傳給PublicationMap的暫存array (新宣告空間，放累績資料的array)
	if (resetMapData) {
		sub_tmpMapData = []; // 放info array 第一筆資料
	}

	if (animationTrans) {
		// 依照動畫節奏給資料
		for (let i = 0; i < info.length; i += 1) {
			sub_tmpMapData.push(info[i]);
		}
	} else {
		// 依照點選柱狀圖的年份累積資料
		sub_tmpMapData = info; // 累計資料整個assign給sub_tmpMapData
	}

	for (let i = 0; i < sub_tmpMapData.length; i += 1) {
		// 放到新宣告的array空間
		tmpMapData.push(sub_tmpMapData[i]);
	}
	// 輸出資料格式  ==>  [{},{},{}....]
	dispatch({
		transMapData: tmpMapData,
		type: Act.TRANSFORM_MAP_DATA,
	});
}

// eslint-disable-next-line consistent-return
async function transformNewData(data) {
	try {
		const oldData = await data;
		const newData = {};
		// {
		//  1975: [{lat: , log: , pubid: },{...}]
		// }
		for (let i = 0; i < oldData.data.length; i += 1) {
			const year = oldData.data[i].startDate;
			if (Object.keys(newData).indexOf(year) >= 0) {
				// 找到資料用push
				newData[year].push(oldData.data[i]);
			} else {
				// 沒找到資料直接assign
				newData[year] = [oldData.data[i]];
			}
		}
		return newData;
	} catch (err) {
		console.log(err);
	}
}

const getMapData = () =>
	new Promise((resolve, reject) => {
		fetch(api.getPublicationMapV2)
			.then((d) => {
				resolve(d.json());
			})
			.catch((err) => {
				reject(err);
				console.log('No fetch API');
			});
	});

// eslint-disable-next-line consistent-return
async function getData() {
	try {
		const _books_pub = []; // 發行年分
		const _books_count = []; // 該年分發行數量
		const _books_info = []; // 該年分所有書的資訊
		const _oldData = await getMapData(); // 原始資料

		const data = await transformNewData(_oldData);
		let count = 0;
		// eslint-disable-next-line guard-for-in
		for (const year in data) {
			_books_pub[count] = year;
			_books_count[count] = data[year].length;
			_books_info[count] = data[year];
			// eslint-disable-next-line no-plusplus
			count += 1;
		}
		return { books_count: _books_count, books_pub: _books_pub, books_info: _books_info, old_data: _oldData };
	} catch (err) {
		console.log(err);
	}
}

function pause() {
	document.querySelector('.canvas').classList.add('pause');
	document.getElementById('btn1').style.display = 'block';
	document.getElementById('btn2').style.display = 'none';
	document.querySelector('.mapMask').style.display = 'none';
}

let lineMoving = 0; // 控制線移動次數
let resetMapData = true; // 改為true時，告訴sub_tmpMapData資料清空
let canvasWidth = 0; // canvas Width
let canvasHeight = 0; // canvas Height
let existDataYear = []; // 只存有資料個年份
let skipIndex = 0; // 控制要塞existDataYear那個有資料年份的位置給lineMoving
const margin = { top: 20, left: 30, bottom: 10, right: 20 };
function listenRectEvent({ books_info, dispatch, books_pub, showYear, showBookCount }) {
	const dataSet = document.querySelectorAll('.dataSet'); // 柱狀圖偵測事件
	const mapMask = document.querySelector('.mapMask');
	// listen event
	for (let i = 0; i < dataSet.length; i += 1) {
		const origin_fill_color = dataSet[i].style.fill;
		dataSet[i].addEventListener('mouseenter', function changeColor(event) {
			this.style.fill = 'blue';
			showBookCount(books_info[i].length);
			document.getElementById('popup').style.opacity = 1;
			document.getElementById('popup').style.left = `${event.offsetX + 25}px`;
			document.getElementById('popup').style.top = `${parseFloat(event.target.attributes.y.nodeValue) - 5}px`;
		});
		dataSet[i].addEventListener('mouseleave', function changeColor() {
			this.style.fill = origin_fill_color;
			document.getElementById('popup').style.opacity = 0;
		});
		dataSet[i].addEventListener('click', () => {
			pause();
			document.querySelector('#inputSearchYear').style.display = 'none';
			document.querySelector('#showYear').style.display = 'block';
			// document.getElementById('showYear').value = ''; // clear search year input value
			if (document.querySelector('.showError').classList.value.indexOf('error') >= 0) {
				// 移除Search有error的狀況
				document.querySelector('.showError').classList.remove('error');
				document.querySelector('.showErrorMsg').style.display = 'none';
			}
			// canvas line move
			lineMoving = i + 1 >= books_info.length ? i : i + 1; // assign (i+1) 避免restart畫面重複加上上一筆info的數量
			skipIndex = existDataYear.findIndex((existYear) => existYear.year === books_pub[i]) + 1;
			skipIndex = skipIndex >= existDataYear.length ? skipIndex - 1 : skipIndex;
			const accumulateData = [];
			for (let j = 0; j <= lineMoving; j += 1) {
				// 紀錄累計年份資料
				if (books_info[j].length === 0) {
					continue;
				}
				for (let k = 0; k < books_info[j].length; k += 1) {
					accumulateData.push(books_info[j][k]);
				}
			}
			animationTrans = false;
			dataTransToMap(accumulateData, dispatch, false);
			showYear(books_info[i][0].startDate); // 線段每次移動就更新年分顯示
			// 傳送資料給SearchInput.js
			dispatch({
				transSearchData: books_info[i][0].startDate,
				type: Act.TRANSFORM_SEARCH_DATA,
			});
		});
	}

	mapMask.addEventListener('click', () => {
		pause();
		document.getElementById('showYear').value = ''; // clear search year input value
		dispatch({
			transSearchData: books_pub[lineMoving],
			type: Act.TRANSFORM_SEARCH_DATA,
		});
	});
}

function skipNoDataYear(books_count, books_pub) {
	existDataYear = books_count
		.map((count, index) => {
			if (count > 0) {
				return {
					year: books_pub[index],
					index,
				};
			}
		})
		.filter((count) => count !== undefined);
}

function lineAnimation({ lineSVG, xscale, books_pub, books_count, books_info, dispatch, showYear }) {
	let pauseMapDataStore = false; // 當資料暫停時，不呼叫dataTransToMap
	skipNoDataYear(books_count, books_pub);
	lineSVG.transition().on('start', function repeat() {
		if (document.querySelector('.canvas') === null) {
			// 切換到其他頁面，不執行動畫
			lineMoving = 0;
			return;
		}

		// 重複輪播動畫
		if (document.querySelector('.canvas').classList.value.indexOf('pause') >= 0) {
			pauseMapDataStore = true;
		}

		if (lineMoving >= books_pub.length) {
			lineMoving = 0;
			skipIndex = 0;
			resetMapData = true;
		}

		if (!pauseMapDataStore) {
			lineMoving = existDataYear[skipIndex].index;
			skipIndex += 1;
			if (skipIndex >= existDataYear.length) {
				lineMoving = 0;
				skipIndex = 0;
				resetMapData = true;
			}
			animationTrans = true;
			dataTransToMap(books_info[lineMoving], dispatch, resetMapData); // 依照動畫節奏output資料給publicationMap
			resetMapData = false;
			showYear(books_pub[lineMoving]);
		}

		pauseMapDataStore = false;
		d3.active(this)
			.transition()
			// .duration(ani_speed)
			.ease(d3.easeLinear)
			.attr('transform', `translate(${xscale.bandwidth() * lineMoving},0)`)
			.on('start', repeat);
	});
}

function drawLine(svgCanvas, xscale, books_pub, books_count, books_info, dispatch, showYear) {
	const lineSVG = svgCanvas
		.append('line')
		.attr('x1', margin.left)
		.attr('y1', margin.top)
		.attr('x2', margin.left)
		.attr('y2', canvasHeight)
		.style('stroke', 'black')
		.style('stroke-width', '5')
		.style('stroke-linecap', 'round');

	svgCanvas
		.append('line') // 中間線
		.attr('x1', margin.left)
		.attr('y1', canvasHeight / 2)
		.attr('x2', margin.left + xscale.bandwidth() * books_pub.length)
		.attr('y2', canvasHeight / 2)
		.style('stroke', 'black')
		.style('stroke-width', '0.8');

	svgCanvas
		.append('line') // 頂端線
		.attr('x1', margin.left)
		.attr('y1', 0)
		.attr('x2', margin.left + xscale.bandwidth() * books_pub.length)
		.attr('y2', 0)
		.style('stroke', 'black')
		.style('stroke-width', '2');

	lineAnimation({ lineSVG, xscale, books_pub, books_count, books_info, dispatch, showYear }); // 線的跑動動畫
}

function drawRec(svgCanvas, xscale, books_pub, books_count, books_info, dispatch, showYear, showBookCount) {
	svgCanvas
		.append('g') // group柱狀圖
		.selectAll('rect') // 選擇所有"rect" tag，剛開始為null
		.data(books_count) // 匯入資料，資料型態是array
		.enter() // 處理array每一筆資料
		.append('rect') // 每個array執行時，增加一個"rect" tag
		.attr('class', 'dataSet')
		.attr('width', xscale.bandwidth() * 4)
		// 依據(平均倍數 => 畫布高度/(最大書本數量+1))計算，公式: 書本數量 * (畫布高度/(最大書本數量+1)); (最大書本數量+1)是為了讓最大數量的長方形不要碰到頂端線
		.attr('height', (data) => data * (canvasHeight / (d3.max(books_count) + 1)))
		.attr('fill', 'orange') // 每個"rect" tag顏色填滿橘色
		.attr('x', (data, index) => xscale(books_pub[index]) + margin.left - xscale.bandwidth()) // 每筆資料(長方形)的x座標起始位置
		.attr('y', (data) => canvasHeight - data * (canvasHeight / (d3.max(books_count) + 1))); // 每筆資料(長方形)y座標起始位置
	listenRectEvent({ books_pub, books_info, dispatch, showYear, showBookCount });
}

function drawAxis({ svgCanvas, books_pub, books_count, books_info, dispatch, showBookCount, showYear }) {
	// let extend_books_pub = []; // 在x軸依照年份依序顯示
	// let extend_books_info = []; // 在y軸每年書本數量，若該年無書本資料，長度為0
	// let extend_books_count = []; // 擴增資料，每筆資料的書本數量，若該年無書本資料，數量為0
	let count = 0; // 擴增陣列計數器
	let count_book_info = 0; // books_info計數器
	for (let i = Math.floor(books_pub[0] / 10) * 10; i <= books_pub[books_pub.length - 1]; i += 1) {
		extend_books_pub[count] = i;
		if (i != parseInt(books_pub[count_book_info])) {
			extend_books_info[count] = [];
			extend_books_count[count] = 0;
		} else {
			extend_books_info[count] = books_info[count_book_info];
			extend_books_count[count] = books_info[count_book_info].length;
			count_book_info += 1;
		}
		count += 1;
	}

	// 定義x軸性質
	const xscale = d3
		.scaleBand() // 比例尺線性圖
		.range([0, canvasWidth]) // 比例尺顯示範圍，例如: 用console.log(xscale(0))確認，與實際顯示長度有關
		.domain(extend_books_pub); // x軸顯示匯入資料
	// 定義底線座標為x軸
	const x_axis = d3.axisBottom(xscale).tickValues(xscale.domain().filter((d, i) => !(i % 50)));
	svgCanvas.append('g').attr('transform', `translate(${margin.left}, ${canvasHeight})`).call(x_axis); // 顯示x軸在svg上

	drawRec(
		svgCanvas,
		xscale,
		extend_books_pub,
		extend_books_count,
		extend_books_info,
		dispatch,
		showYear,
		showBookCount
	); // 畫柱狀圖
	drawLine(svgCanvas, xscale, extend_books_pub, extend_books_count, extend_books_info, dispatch, showYear); // 畫線
}

// TimeLine component
const TimeLine = () => {
	// const canvas = useRef(null); // 用useRef優先抓取設定元件
	const [year, showYear] = useState(0); // 顯示時間軸相對應年份
	const [bookCount, showBookCount] = useState(0); // popup顯示書本數量
	const [state, dispatch] = useContext(StoreContext);

	useEffect(() => {
		let books_count = []; // 該年分發行書本數量
		let books_pub = []; // 書本發行年分
		let books_info = []; // 該年分所有書的資訊

		// reset map data
		lineMoving = 0;
		skipIndex = 0;
		resetMapData = true;

		// reset search data
		dispatch({
			transSearchData: '',
			type: Act.TRANSFORM_SEARCH_DATA,
		});

		const width = document.getElementById('canvas').clientWidth - margin.left - margin.right;
		const height = document.getElementById('canvas').clientHeight - margin.top - margin.bottom;
		canvasWidth = width;
		canvasHeight = height;

		getData()
			.then((fetchData) => {
				books_count = fetchData.books_count;
				books_pub = fetchData.books_pub;
				books_info = fetchData.books_info;
				old_data = fetchData.old_data;
				const svgCanvas = d3.select('#canvas').attr('width', width).attr('height', height);

				drawAxis({
					svgCanvas,
					books_pub,
					books_count,
					books_info,
					dispatch,
					showYear,
					showBookCount,
				}); // 畫x軸座標線
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	function changeBtn(e) {
		e.preventDefault();
		if (document.getElementById('btn2').style.display === 'none') {
			// start
			document.getElementById('showYear').value = ''; // clear search year input value
			document.getElementById('btn2').style.display = 'block';
			document.getElementById('btn1').style.display = 'none';
			if (document.getElementById('canvas').classList.value.indexOf('pause') >= 0) {
				document.getElementById('canvas').classList.remove('pause');
			}
			document.querySelector('.mapMask').style.display = 'block';

			if (document.querySelector('.showError').classList.value.indexOf('error') >= 0) {
				// 移除有error的狀況
				document.querySelector('.showError').classList.remove('error');
				document.querySelector('.showErrorMsg').style.display = 'none';
			}

			document.getElementById('showYear').style.display = 'block';
			document.getElementById('inputSearchYear').style.display = 'none';
		} else {
			// block
			document.getElementById('btn1').style.display = 'block';
			document.getElementById('btn2').style.display = 'none';
			if (document.getElementById('canvas').classList.value.indexOf('pause') < 0) {
				document.getElementById('canvas').classList.add('pause');
			}
			document.querySelector('.mapMask').style.display = 'none';
			dispatch({
				transSearchData: extend_books_pub[lineMoving],
				type: Act.TRANSFORM_SEARCH_DATA,
			});
		}
	}

	function pauseYear() {
		document.getElementById('showYear').style.display = 'none';
		document.getElementById('inputSearchYear').style.display = 'block';
		document.getElementById('inputSearchYear').value = year;
		document.getElementById('inputSearchYear').setAttribute('autofocus', true);
		pause();
	}

	function setYear(event) {
		if (event.key === 'Enter') {
			let searchYear = document.getElementById('inputSearchYear').value;
			let rangeCheck = false;
			if (searchYear >= extend_books_pub[0] && searchYear <= extend_books_pub[extend_books_pub.length - 1]) {
				rangeCheck = true;
			} else {
				searchYear = year;
			}
			document.querySelector('.message p').innerHTML = `Year Range <br />${extend_books_pub[0]}~${
				extend_books_pub[extend_books_pub.length - 1]
			}`;
			if (rangeCheck) {
				if (document.querySelector('.showError').classList.value.indexOf('error') >= 0) {
					// 移除有error的狀況
					document.querySelector('.showError').classList.remove('error');
					document.querySelector('.showErrorMsg').style.display = 'none';
				}
			} else {
				document.querySelector('.showError').classList.add('error');
				document.querySelector('.showErrorMsg').style.display = 'block';
			}

			// 暫停時，將下一個要指定的年份指向有資料的那年，如果尋找年份剛好有資料，指向該年
			for (let i = 0; i < existDataYear.length; i += 1) {
				if (existDataYear[i].year >= searchYear) {
					skipIndex = i;
					break;
				}
			}

			lineMoving =
				searchYear >= extend_books_pub[0] && searchYear <= extend_books_pub[extend_books_pub.length - 1]
					? searchYear - extend_books_pub[0]
					: lineMoving;
			showYear(searchYear); // 線段每次移動就更新年分顯示
			// 傳送資料給SearchInput.js
			dispatch({
				transSearchData: searchYear,
				type: Act.TRANSFORM_SEARCH_DATA,
			});

			const accumulateData = [];
			for (let j = 0; j <= lineMoving; j += 1) {
				// 紀錄累計年份資料
				if (extend_books_info[j].length !== 0) {
					for (let k = 0; k < extend_books_info[j].length; k += 1) {
						accumulateData.push(extend_books_info[j][k]);
					}
				}
			}
			animationTrans = false;
			dataTransToMap(accumulateData, dispatch, false);
		}
	}

	return (
		<div className="timeline">
			<div className="showYear">
				<form autoComplete="off">
					<div className="ui input showError">
						<input type="text" id="showYear" value={year} onClick={pauseYear} readOnly />
						<input type="text" id="inputSearchYear" style={{ display: 'none' }} onKeyPress={setYear} />
					</div>{' '}
					&nbsp;
					<span>Year</span>
				</form>
				<div className="ui negative message showErrorMsg" style={{ display: 'none' }}>
					<p />
				</div>
			</div>
			<div className="svgDiv" id="svgDiv">
				<div className="canvasDiv">
					<svg className="canvas" id="canvas" />
				</div>
				<div id="popup">{bookCount}</div>
				<div className="btn">
					<a href="#" id="btn1" onClick={changeBtn} style={{ display: 'none' }}>
						<i className="far fa-play-circle" />
					</a>
					<a href="#" id="btn2" onClick={changeBtn}>
						<i className="far fa-pause-circle" />
					</a>
				</div>
			</div>
		</div>
	);
};

export default TimeLine;
